import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './Hierarchy.css'
import { fetchHierarchy, toggleExpanded, collapseAll } from '../redux/hierarchy'
import InteractiveHierarchy from '../components/InteractiveHierarchy'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import { SPECIAL_ALBUM_PATH_TITLE } from '../constants'

const SPECIAL_ALBUMS = [
  {
    text: SPECIAL_ALBUM_PATH_TITLE['null'],
    href: '/album',
    query: {
      path: 'null',
      referrer: 'hierarchy'
    }
  },
  {
    text: SPECIAL_ALBUM_PATH_TITLE['event:null'],
    href: '/album',
    query: {
      path: 'event:null',
      referrer: 'hierarchy'
    }
  },
  {
    text: SPECIAL_ALBUM_PATH_TITLE['keyword:null'],
    href: '/album',
    query: {
      path: 'keyword:null',
      referrer: 'hierarchy'
    }
  }
]

class Hierarchy extends Component {
  componentDidMount () {
    const { hierarchy, fetchHierarchy } = this.props
    if (!hierarchy) {
      fetchHierarchy()
    }
  }
  render () {
    const { hierarchy, fetching, error, fetchHierarchy } = this.props

    if (error) {
      return (
        <ErrorMessage
          message='There was an error fetching the hierarchy'
          onRetry={fetchHierarchy}
        />
      )
    }

    if (!hierarchy || fetching) {
      return <LoadingSpinner />
    }

    const { full } = this.props

    return (
      <div className={classNames.page}>
        <InteractiveHierarchy hierarchy={hierarchy} prefix='/COLLECTIONS' />
        {full &&
          <div className={classNames.heading}>
            Raw hierarchy
          </div>
        }
        {full &&
          <InteractiveHierarchy hierarchy={full} appendItems={SPECIAL_ALBUMS} />
        }
      </div>
    )
  }
}

const mapStateToProps = ({ hierarchy, auth }) => ({
  hierarchy: hierarchy.data,
  full: hierarchy.full,
  expanded: hierarchy.expanded,
  fetching: hierarchy.fetching,
  error: hierarchy.error
})

const mapDispatchToProps = {
  fetchHierarchy,
  toggleExpanded,
  collapseAll
}

export default connect(mapStateToProps, mapDispatchToProps)(Hierarchy)




// WEBPACK FOOTER //
// ./src/pages/Hierarchy.js